import { State } from './reducer';

export const createConnectingSelector = (actions: string[]) => (state: State) =>
  actions.some((action) => state[action]);
